import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import toast from 'react-hot-toast';

import { selectCurrentUser } from '../../redux/user/user.selectors';
import { selectCurrentDistro } from '../../redux/distro/distro.selector';
import { sessionExpired, updateDistros, updateToken } from '../../redux/user/user.actions';
import { setCurrentDistro } from '../../redux/distro/distro.actions';
import { authFetch, getApiUrl } from '../../utils/api';
import { reconcileFirmAccess } from '../../utils/firmAccess';

const FirmAccessSync = (props) => {
    const location = useLocation();
    const latest = useRef(props);
    latest.current = props;
    const requestId = useRef(0);

    const { currentUser } = props;
    const shouldSync = !!currentUser?.token && (!currentUser.opsActor || currentUser.opsScopeKind === 'user') && currentUser.role !== 'advisor';

    useEffect(() => {
        if (!shouldSync) return;
        const id = ++requestId.current;

        const sync = async () => {
            const { currentUser, onSessionExpired, onTokenRefresh } = latest.current;
            const response = await authFetch(
                `${getApiUrl()}/users/firm-access`,
                {},
                { currentUser, onSessionExpired, onTokenRefresh }
            );
            if (!response.ok) return;
            const { distros } = await response.json();
            if (id !== requestId.current) return;

            const { currentUser: user, currentDistro, onAccessRemoved, updateDistros, setCurrentDistro } = latest.current;
            if (!user) return;
            const result = reconcileFirmAccess(user, currentDistro, distros || []);
            if (result.signOut) {
                onAccessRemoved();
                return;
            }
            if (result.changed) updateDistros(distros);
            if (result.nextDistro !== currentDistro) setCurrentDistro(result.nextDistro);
            if (result.notice) toast(result.notice);
        };

        sync().catch(() => {});
    }, [location.pathname, location.search, shouldSync]);

    return null;
};

const mapStateToProps = createStructuredSelector({
    currentUser: selectCurrentUser,
    currentDistro: selectCurrentDistro,
});

const mapDispatchToProps = (dispatch) => ({
    onSessionExpired: () => dispatch(sessionExpired()),
    onAccessRemoved: () => dispatch(sessionExpired('accessChanged')),
    onTokenRefresh: (token) => dispatch(updateToken(token)),
    updateDistros: (distros) => dispatch(updateDistros(distros)),
    setCurrentDistro: (distro) => dispatch(setCurrentDistro(distro)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FirmAccessSync);
